module.exports = __webpack_public_path__ + "img/tcndxq_img5-6.5c4ad59d.png";